import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { useAuth } from "@/context/AuthContext";
import { ProductCard } from "@/components/ProductCard";

export default function WishlistPage() {
  const { ids } = useWishlist();
  const { user } = useAuth();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (user) {
      api.get("/wishlist").then((r) => setProducts(r.data)).catch(() => {});
    } else if (ids.length) {
      Promise.all(ids.map((id) => api.get(`/products/${id}`).then((r) => r.data).catch(() => null)))
        .then((list) => setProducts(list.filter(Boolean)));
    } else {
      setProducts([]);
    }
  }, [user, ids]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-display text-4xl sm:text-5xl font-light mb-8 flex items-center gap-3">
        <Heart className="w-7 h-7 text-primary fill-primary" /> Wishlist
      </h1>
      {products.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-muted-foreground font-light">Your wishlist is empty.</p>
          <Link to="/shop" className="inline-block mt-6 bg-foreground text-[hsl(var(--ivory))] px-10 py-4 text-xs uppercase tracking-[0.2em] hover:bg-primary transition-colors" data-testid="wishlist-shop-btn">Discover styles</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
          {products.map((p, i) => (
            <div key={p.id} data-aos="fade-up" data-aos-delay={(i % 4) * 100}><ProductCard p={p} /></div>
          ))}
        </div>
      )}
    </div>
  );
}
